export default __webpack_public_path__ + "static/safari-413c91aecd2a83fec61db13b9873afac.png";